package com.cybersoftsolution.cybersoftsolutionweb.use_cases

import com.cybersoftsolution.cybersoftsolutionweb.api.logIn
import com.cybersoftsolution.cybersoftsolutionweb.utils.Utils.showTemporaryTextMessage
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.rememberLogin
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

fun CoroutineScope.logInUseCase(
    remember: Boolean,
    asAdmin: Boolean,
    userName: String,
    password: String,
    setErrorText: (errorMessage:String) -> Unit,
    onLoginSuccess: (successMessage:String?) -> Unit
){


    setErrorText(" ")

    this.launch {
        if(userName.isNotEmpty() && password.isNotEmpty()){

            logIn(userName, password).also { it ->
                it?.let { response ->


                    if (response.success==true && !response.userInfo?.id.isNullOrEmpty() && !response.userInfo?.authorizationToken.isNullOrEmpty()) {

                        if (asAdmin && response.userInfo?.isAdmin != true) {
                            showTemporaryTextMessage( "Acceso denegado"){setErrorText(it)}
                            return@launch
                        }

                        rememberLogin(
                            remember = remember,
                            userId = response.userInfo?.id,
                            authorizationToken = response.userInfo?.authorizationToken,
                            userName = response.userInfo?.name,
                            userEmail = response.userInfo?.email,
                            userEmailVerified = response.userInfo?.emailVerified,
                            userPhone = response.userInfo?.phone,
                            userPicture = response.userInfo?.picture,
                        )

//                        this.router.navigateTo(
//                            Screen.AdminHome.route,
//                            UpdateHistoryMode.REPLACE,
//                            OpenLinkStrategy.IN_PLACE,
//                        )

                        onLoginSuccess(response.successMessage)


                    } else {
                        when(response.errorMessage){
                            "User not found" -> showTemporaryTextMessage("Usuario no encontrado") { setErrorText(it) }
                            "Wrong password" -> showTemporaryTextMessage( "Contraseña incorrecta"){setErrorText(it)}
                            "User is not enable" -> showTemporaryTextMessage( "Usuario deshabilitado"){setErrorText(it)}
                            else -> showTemporaryTextMessage( "Error desconocido"){setErrorText(it)}
                        }

                    }




                }?:(
                        showTemporaryTextMessage( "Error de conexion"){setErrorText(it)}
                        )

            }





        } else {
            showTemporaryTextMessage( "Por favor ingrese sus credenciales"){setErrorText(it)}
        }

    }



}
